module.exports = __webpack_public_path__ + "static/media/team-4.748f233f.jpg";